import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 339 339' fill={fillColor} className={className}>
      <path d='M289.354377,49.6449609 C257.340064,17.6313105 214.775039,0 169.5,0 C124.224299,0 81.6586113,17.6313105 49.6449609,49.6449609 C17.6306484,81.6592734 0,124.224961 0,169.5 C0,214.775039 17.6306484,257.340064 49.6449609,289.354377 C81.6592734,321.368689 124.224299,339 169.5,339 C214.775039,339 257.340064,321.368689 289.354377,289.354377 C321.368689,257.340064 339,214.775039 339,169.5 C339,124.224961 321.368689,81.6599355 289.354377,49.6449609 Z M169.5,319.136719 C86.989916,319.136719 19.8632812,252.010084 19.8632812,169.5 C19.8632812,86.989916 86.989916,19.8632812 169.5,19.8632812 C252.010084,19.8632812 319.136719,86.989916 319.136719,169.5 C319.136719,252.010084 252.010084,319.136719 169.5,319.136719 Z' />
      <path d='M169.4,133 C164.6,133 161,136.6 161,141.4 L161,252.6 C161,257.4 164.6,261 169.4,261 C174.2,261 177.8,257.4 177.8,252.6 L177.8,141.4 C177.8,136.6 174.2,133 169.4,133 Z' />
      <circle cx='169.8' cy='93.8' r='14.8' />
    </svg>
  );
});

export default React.memo(Icon);
